export const PATIENT_UNIT = {
  BLOOM: 'bloom',
  MOVE: 'move',
  SWORD: 'sword',
  MIND: 'mind',
} as const

export type MemberUnitType = (typeof PATIENT_UNIT)[keyof typeof PATIENT_UNIT]
